// extracted by mini-css-extract-plugin
export default {"customMessage":"ClosableMessage_customMessage__gdsqI","closeIcon":"ClosableMessage_closeIcon__nqBgc"};